<template>
  <div>
    <v-responsive :aspect-ratio="16/9">
      <script 
        ref="player"
        :data-videohub-id="content.content" 
        :src="`https://evolucional.videohub.com.br/embed.js?${now}`" 
        type="module"
      />
    </v-responsive>
  </div>
</template>
<script>

import vueVimeoPlayer from 'vue-vimeo-player'
import Vue from 'vue'
import PlayerOptionsMixin from './PlayerOptionsMixin'
Vue.use(vueVimeoPlayer)

export default {
  mixins: [
    PlayerOptionsMixin
  ],
}
</script>
<style lang="scss" scoped>
iframe {
  height: 100% !important;
}
</style>